import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";


function BranchesPage() {

    const [isSwitchOn, setIsSwitchOn] = useState(false);
    const tamilnaduRef = useRef(null);
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    function toggleSwitch(switchId, switchValue) {
        var switchElement = document.getElementById(switchId);
        switchElement.checked = switchValue; // Set the switch state based on the argument
        setIsSwitchOn(switchValue); // Update the state
        if (switchValue) {
            // Scroll to Tamil Nadu section when the switch is on
            window.scrollTo({
                top: tamilnaduRef.current.offsetTop,
                behavior: 'smooth',
            });
        }
    }
    return (
        <div>
            <div className='container'>
                <div className='top-branchs'>
                    <div className='row v-gap-30'>
                        <div className='col-md-6'>
                            <div className='branch-box'>

                                <div className='ourBranchs'>
                                    <h3 className=''>OUR BRANCHES</h3>
                                    {/* <div className='branch-btns'>
                                        <button type="submit" onClick={() => toggleSwitch('darkSwitch', false)}>KARNATAKA</button>
                                        <span style={{ paddingLeft: "12px" }}></span>
                                        <button type="submit" onClick={() => toggleSwitch('darkSwitch', true)}>TAMIL NADU</button>
                                    </div> */}
                                    {/* <div className="d-flex justify-content-center custom-control custom-switch " >
                                                <input type="checkbox" className="custom-control-input" id="darkSwitch" />
                                                <label className="custom-control-label" for="darkSwitch"></label>
                                            </div> */}

                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>Hyderabad</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Vajra Residency</strong></p>
                                                <p>203 A Block 1st Floor, Musheerabad Main Road, Bakaram, Kavadiguda, Hyderabad, Telangana 500080 Opposite Metro Pillar Number 1073</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n4XTW6ttak85hklxkj3lXAMN879Dw:1780563899563&kgmid=/g/11ldwnjdrn&q=Sristar+Gold+Company+-+Gold+Buyers+in+Hyderabad&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=dcb652e890f730b2&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.941061960208!2d78.49507477501078!3d17.414615883477186!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99ed2c37a49f%3A0x532640615a1e00e1!2sVajra%20Residency%2C%20Musheerabad%20Main%20Rd%2C%20Bakaram%2C%20Kavadiguda%2C%20Hyderabad%2C%20Telangana%20500080!5e0!3m2!1sen!2sin!4v1710668316231!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>BENGALURU Corporate Office</h3>
                                                <p style={{ fontSize: '13px' }}><strong>18th Cross, Malleshwaram</strong></p>
                                                <p>280/1, Anniamma Arcade, Sampige Road, 18th Cross Rd, Malleshwaram, Bengaluru, Karnataka 560003</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5Vtby4BJ12dIhCLErosaqEzb88kA:1780563895714&kgmid=/g/11q4z2gb38&q=SriStar+Gold+Company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=518fd72067fa7c7d&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.4293233636236!2d77.5713097!3d13.008309899999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae162da7d2bdd1%3A0x5e253f56dcb22d40!2sAnniamma%20Arcade%2C%2018th%20Cross%20Rd%2C%20Ranganathapura%2C%20Malleshwara%2C%20Bengaluru%2C%20Karnataka%20560003!5e0!3m2!1sen!2sin!4v1701346250310!5m2!1sen!2sin" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>BENGALURU</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Margosa Road</strong></p>
                                                <p>Shop No 2, 2nd Floor, Margosa Building, 13th Cross Road, Margosa Rd, opp. City Union Bank, Malleshwaram, Bengaluru, Karnataka 560003</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5V6G4YNKuWV0T2eg8oXsWgC7wnkw:1780563696766&kgmid=/g/11npsdjq1g&q=Sristar+Gold+Company+-+Margosa+Road&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=33c5819ae86e4978&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe title="Margosa Road Branch" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.5016561982816!2d77.5694722!3d13.0036996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae17355153cfc5%3A0x895697669d0d3b6f!2sSristar%20Gold%20Company%20-%20Margosa%20Road!5e0!3m2!1sen!2sin!4v1775450969568!5m2!1sen!2sin" width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>Tumkur</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Honnavar Hwy </strong></p>
                                                <p>opposite Tumkur University College, Opposite University College, Venkatesh Rao Colony, Tumakur, Karnataka 572103</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/maps/place/SriStar+Gold+Company+-+Tumkuru/@13.3365651,77.1223788,17z/data=!3m1!4b1!4m6!3m5!1s0x3bb02dad3794a4a3:0xe8f6c8b327c49449!8m2!3d13.3365651!4d77.1223788!16s%2Fg%2F11z1_wv_lm?entry=ttu'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3868.455087612666!2d77.1223788!3d13.3365651!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb02dad3794a4a3%3A0xe8f6c8b327c49449!2sSriStar%20Gold%20Company%20-%20Tumkuru!5e0!3m2!1sen!2sin!4v1781173063772!5m2!1sen!2sin" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>MYSURU</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Sunnadakeri 4th cross </strong></p>
                                                <p>No. 912 Susheel Building, 2nd floor, Sunnadakeri 4th cross, N S Road, Opp Nakshtra Complex, Mysuru, 570024</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n60bBedVWeFmH7meUrtPHPHZQQBig:1780563903837&kgmid=/g/11st67z_3j&q=Sristar+Gold+Company+-+Mysuru&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=32f67d2a21be27b5&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3898.231033655112!2d76.6469573!3d12.3002276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baf718d7f25964f%3A0x6b8f36c568f18706!2sSristar%20Gold%20Company%20-%20Mysuru!5e0!3m2!1sen!2sin!4v1702554689928!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>MANGALORE</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Pioneer Complex</strong></p>
                                                <p> D/No - 20-3-293-26, Maidan Rd, near State Bank, Uppinagadi Village, Mangaluru, Karnataka 575001</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/maps/place/SriStar+Gold+Company+-+Mangalore/@12.8696988,74.8453076,17z/data=!3m1!4b1!4m6!3m5!1s0x3ba35b30cbab81cb:0x76c49c1eebd93a5b!8m2!3d12.8696988!4d74.8453076!16s%2Fg%2F11kjz98wsy?entry=ttu'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.590674860451!2d74.8453076!3d12.8696988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba35b30cbab81cb%3A0x76c49c1eebd93a5b!2sSriStar%20Gold%20Company%20-%20Mangalore!5e0!3m2!1sen!2sin!4v1701912764518!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>DAVANAGERE</h3>
                                                <p style={{ fontSize: '13px' }}><strong>PB Road </strong></p>
                                                <p>150/3A, PB Rd, opposite Reliance Smart Bazar, KB Extension, Davangere, Karnataka 577002</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/maps/place/Sristar+Gold+Company+-+Davanagere/@14.4715423,75.926418,17z/data=!3m1!4b1!4m6!3m5!1s0x3bba2515fc9279fd:0xce8c17d22e85f3d1!8m2!3d14.4715423!4d75.926418!16s%2Fg%2F11w8xd4g4l?entry=ttu'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3844.757833076939!2d75.926418!3d14.4715423!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bba2515fc9279fd%3A0xce8c17d22e85f3d1!2sSristar%20Gold%20Company%20-%20Davanagere!5e0!3m2!1sen!2sin!4v1781173128704!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>HAVERI</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Hosamani Siddappa Circle</strong></p>
                                                <p>Gudagar Complex, 1st Floor Hosamani Siddappa Circle Beside KGP, Jewelry Haveri - 581110</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n7EJ6GYr8u1nooDkG00RyW8h9Xbnw:1780563893818&kgmid=/g/11vz8109cq&q=SRISTAR+GOLD+COMPANY&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=ec3acba93d364258&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3857.665216815006!2d75.3991418!3d14.7878828!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb96924dede49c1%3A0x9e9aca1b164a78b8!2sSRISTAR%20GOLD%20COMPANY!5e0!3m2!1sen!2sin!4v1701913809792!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>HUBLI</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Tirumala Trade Centre</strong></p>
                                                <p>Shop No 40, Ground Floor, Tirumala Trade Centre, Neeligin Rd, Deshpande Nagar, Hubballi, Karnataka 580029</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/maps/place/SRISTAR+GOLD+COMPANY/@15.357199,75.1310656,17z/data=!3m1!4b1!4m6!3m5!1s0x3bb8d7a28ebc47b7:0x8c849cca35e02a74!8m2!3d15.357199!4d75.1310656!16s%2Fg%2F11w975x8c9?entry=ttu'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3840.4071378875576!2d75.1310656!3d15.357199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d7a28ebc47b7%3A0x8c849cca35e02a74!2sSRISTAR%20GOLD%20COMPANY!5e0!3m2!1sen!2sin!4v1781510670444!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>RAICHUR</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Gunj Road </strong></p>
                                                <p>12-10-18/1A, 1st Floor, Gunj Road,Near Vaikuntam Complex, Raichur - 584101</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n6ehPvVnbcuqR1TjlLBTdMJrgHFGA:1780563900160&kgmid=/g/11w9149n6m&q=Sristar+Gold+Company+-+Gold+Buyers+in+Raichur&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=209b120e70eee863&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3835.918526553957!2d77.3604084!3d16.2045617!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf43d46747209%3A0x8798e4f559b32943!2sSristar%20Gold%20Company%20-%20Gold%20Buyers%20in%20Raichur!5e0!3m2!1sen!2sin!4v1702555502070!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>SHIVAMOGGA</h3>
                                                <p style={{ fontSize: '13px' }}><strong>NT Road</strong></p>
                                                <p>89/1 - 1066/1 28, NT Rd, opp. URDU SCHOOL, R.M.L Nagar, Milagatta, Shivamogga, Karnataka 577202</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n5FicBLFBTtGXvpbNvOzTpXb9U1HQ:1780563896018&kgmid=/g/11vywv92l6&q=SriStar+gold+company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=bab76e9855ffb162&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1985799.0439653858!2d75.24568719432234!3d13.565393282010838!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbba9005d46f147%3A0x8035c179540d9d49!2sSriStar%20gold%20company!5e0!3m2!1sen!2sin!4v1781173090437!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='branchs-grid'>
                                <div className='row no-gutters'>
                                    <div className='col-md-5'>
                                        <div className='branches-outer'>
                                            <div className='brnch-text'>
                                                <h3>CHENNAI</h3>
                                                <p style={{ fontSize: '13px' }}><strong>Mount Road </strong></p>
                                                <p>No 9, JV White House, 1st Floor, Blackers Road, Anna Salai, Chennai, Tamil Nadu 600002</p>

                                            </div>
                                            <a className='text-decoration-none' href='https://www.google.com/search?sca_esv=780a66cf752212b8&hl=en-GB&authuser=1&sxsrf=ANbL-n4A2h1FmXq2PRwiKxNb9O4Sm-ltyg:1780563896622&kgmid=/g/11rscd3gtz&q=Sristar+Gold+Company&shem=dlvs1,rimspwouoe&shndl=30&source=sh/x/loc/uni/m1/1&kgs=0a06888a737e78c3&utm_source=dlvs1,rimspwouoe,sh/x/loc/uni/m1/1'>
                                                <button type="submit">Get directions</button>
                                            </a>
                                        </div>
                                    </div>
                                    <div className='col-md-7'>
                                        <div className='branch-ifreame'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3886.4918824855918!2d80.26828157507813!3d13.06798248725631!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTPCsDA0JzA0LjciTiA4MMKwMTYnMTUuMSJF!5e0!3m2!1sen!2sin!4v1702555711511!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='avalilable-area'>
                <div className='container'>
                    <div className="sub-hading"><h2>OTHER<strong> SERVICEABLE</strong> AREAS</h2></div>
                    <div className='inner-area-avl' ref={tamilnaduRef}>
                        <div style={{ position: 'relative', padding: '0 40px' }}>
                            <button
                                ref={prevRef}
                                className="swiper-button-prev custom-prev-arrow"
                                style={{
                                    position: 'absolute',
                                    left: '0px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 10,
                                    background: '#D4AF37',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ❮
                            </button>
                            <Swiper
                                modules={[Navigation]}
                                navigation={{
                                    prevEl: prevRef.current,
                                    nextEl: nextRef.current,
                                }}
                                spaceBetween={20}
                                slidesPerView={3}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 10,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                        spaceBetween: 15,
                                    },
                                    1024: {
                                        slidesPerView: 3,
                                        spaceBetween: 20,
                                    },
                                }}
                                onBeforeInit={(swiper) => {
                                    swiper.params.navigation.prevEl = prevRef.current;
                                    swiper.params.navigation.nextEl = nextRef.current;
                                    swiper.navigation.init();
                                    swiper.navigation.update();
                                }}
                            >
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>BIDAR</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121488.11835089335!2d77.34688371403578!3d17.90864575639416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcec722d6908ce5%3A0xb9a71b6e00adff6c!2sBidar%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1703225839789!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>KOLAR</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31084.138180565446!2d78.1260753!3d13.1297385!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3badf08b9595accd%3A0x43ef935427fdf3d0!2sKolar%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1701413434699!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>COIMBATORE</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125322.50873824842!2d76.967235!3d11.013968899999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba859af2f971cb5%3A0x2fc1c81e183ed282!2sCoimbatore%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>BIJAPUR</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121488.11835089335!2d75.7139!3d16.8303!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bca6d0db8da0001%3A0xf00ce6f247884fb0!2sBijapur%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>HASSAN</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d75.7139!3d13.3333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb49da2e0b69895%3A0x5c8aab9a5b8e8e8e!2sHassan%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>GULBARGA</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121488.11835089335!2d77.1298!3d17.3257!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcbf3c53c5c5c5d%3A0x7c5c5c5c5c5c5c5c!2sGulbarga%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>BALLARI</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d75.6409!3d15.1417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8e8e8e8e8e8e9%3A0x8e8e8e8e8e8e8e8e!2sBellary%2C%20Karnataka!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>BAGALKOTE</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61545.14364502598!2d75.6703565!3d16.1741517!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc768393e18a03b%3A0x67310570b615926c!2sBagalkot%2C+Karnataka!5e0!3m2!1sen!2sin!4v1718090000000!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>KAMAREDDY</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d78.3316!3d18.3146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcc71689230559f%3A0x1d14909a3411b066!2sKamareddy%2C%20Telangana!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>KHAMMAM</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d80.1514!3d17.2473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3580a1334c9c1b%3A0x296dc681de4cb1cf!2sKhammam%2C%20Telangana!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>MANCHERIAL</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d79.4439!3d18.8680!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a335f991fcae135%3A0x5a2d677610fb183b!2sMancherial%2C%20Telangana!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>SRIKAKULAM</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121488.11835089335!2d84.2968!3d18.2865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3c5c5c5c5c5c5d%3A0x5c5c5c5c5c5c5c5c!2sSrikakulam%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>RAJAHMUNDRY</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d121488.11835089335!2d81.7899!3d17.0260!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a2d5d5d5d5d5d5d%3A0x5d5d5d5d5d5d5d5d!2sRajamandry%2C%20Andhra%20Pradesh!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>ANANTHAPURAM</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d123533.8587123956!2d77.5165!3d14.6800!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb60b134803a62f%3A0x6b2628d09796e62c!2sAnantapur%2C+Andhra+Pradesh!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>TIRUVANNAMALAI</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124656.1!2d79.0267!3d12.2267!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bac4f5b5b5b5b5b%3A0x5b5b5b5b5b5b5b5b!2sTiruvannamalai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>THANJAVUR</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125322.50873824842!2d79.083166!3d10.786999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3baab8997c111003%3A0x117498c8f000b080!2sThanjavur%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1701413588280!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className='col-others'>
                                        <div className='subbranches-outer'>
                                            <h3>TIRUVALLUR</h3>
                                        </div>
                                        <div className='iFreme-cont'>
                                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d124424.34645474606!2d79.89667793081829!3d13.144465223381666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a528646b9a89d71%3A0x6730704043952934!2sTiruvallur%2C+Tamil+Nadu!5e0!3m2!1sen!2sin!4v1718080000000!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                            <button
                                ref={nextRef}
                                className="swiper-button-next custom-next-arrow"
                                style={{
                                    position: 'absolute',
                                    right: '0px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    zIndex: 10,
                                    background: '#D4AF37',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                ❯
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BranchesPage